export const LOGIN_USER = "LOGIN_USER"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"

export const LOGOUT_USER = "LOGOUT_USER"
export const LOGOUT_USER_SUCCESS = "LOGOUT_USER_SUCCESS"
export const API_ERROR = "LOGIN_API_ERROR"

export const FETCH_EMPRESAS = "FETCH_EMPRESAS"
export const FETCH_EMPRESAS_SUCCESS = "FETCH_EMPRESAS_SUCCESS"
export const FETCH_EMPRESAS_ERROR = "FETCH_EMPRESAS_ERROR"
export const SET_EMPRESA_SELECCIONADA = "SET_EMPRESA_SELECCIONADA"